// @ts-nocheck

export const GRVersion = '2.0.0';
